// extracted by mini-css-extract-plugin
export default {"title":"BuyPackage_title__v9HlT","subtitle":"BuyPackage_subtitle__tqHF+"};